<template>
  <div class="container-fluid">
    <div class="row d-flex justify-content-center">
      <div class="col-lg-10">
        <h1 class="heading-color text-center p-5">Sell Sheets</h1>
      </div>
    </div>
    <div class="row d-flex justify-content-center" v-if="this.$store.getters.apiStatus !== 'loading'">
      <div class="col-lg-10">
        <div class="overlay">
          <div class="main-loader">
            <MainLoader></MainLoader>
          </div>
        </div>
        <div class="row">
          <ItemCard v-for="category in categories" :key="category.id" :item="category" :nextLink="'/category/' + category.id + '/sell-sheets'"></ItemCard>
        </div>
      </div>
    </div>
    <div class="main-loader" v-else>
      <MainLoader></MainLoader>
    </div>
  </div>
</template>

<script>
import SellSheetCategory from '@/models/SellSheetCategory'
import ItemCard from '@/components/ItemCard'
export default {
  name: 'SellSheetCategories',
  components: {
    ItemCard
  },
  data () {
    return {
      categories: null
    }
  },
  mounted () {
    this.fetchSellSheetCategories()
  },
  methods: {
    fetchSellSheetCategories () {
      this.categories = []
      $('.overlay').removeClass('d-none')
      this.$store.dispatch('fetchSellSheetCategories')
        .then((result) => {
          result.data.sell_sheets_categories.forEach(category => {
            this.categories.push(new SellSheetCategory(category))
          })
          $('.overlay').addClass('d-none')
        })
        .catch((err) => console.log(err))
    }
  }
}

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/SellSheetCategories.vue